import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { TourId } from 'webapp/enums/tour';

import type BoardsIndexController from 'webapp/controllers/boards/index';

export default class BoardsIndexRoute extends Route {
	@service('tour') declare tourService: Service.Tour;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('user-settings') declare userSettingsService: Service.UserSettings;
	@service('flow/board-loop-promo')
	declare flowBoardLoopPromoService: Service.Flow.BoardLoopPromo;
	@service('flow/invite-users-promo')
	declare flowInviteUsersPromoService: Service.Flow.InviteUsersPromo;

	override beforeModel(): Promise<unknown> {
		document.body.id = 'page-boards';

		return this.navigationService.initialRequestsPromise;
	}

	override setupController(controller: BoardsIndexController): void {
		controller.loadViewSettings();

		this.userSettingsService.updateFirstWizardEligibility();
		if (
			this.tourService.isEligibleForWizardFirstTour &&
			!this.tourService.isEligibleForDesignerIntroTour
		) {
			const tour = this.tourService.initTour(TourId.WIZARD_FIRST);
			if (tour) {
				tour.start();
			}
		}

		this.flowBoardLoopPromoService.checkToOpenPopup();
	}
}
